import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { NextRequest } from "next/server";
import { geolocation } from "@vercel/functions";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getMediaQuery(mqString) {
  return matchMedia(mqString).matches;
}

export function getUserLocaleServerside(req: NextRequest) {
  // get country code from cloudflare headers
  const { country } = geolocation(req);

  return { country };
}
